import { create } from "zustand";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../components/updateProfile/firebaseConfig";

export const useUserStore = create((set) => ({
  currentUser: "",
  isLoading: true,
  fetchUserInfo: async (uid) => {
    if (!uid) return set({ currentUser: "", isLoading: false });

    try {
      const docRef = doc(db, "users", uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        set({currentUser:docSnap.data(), isLoading: false});
      } else { 
        set({ currentUser:"", isLoading: false })
      }
    } catch (err) {
      console.log(err);
      return set({ currentUser: "", isLoading: false });
    }
  },
}));
